import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _repeatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/repeat";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import * as _ from "../../../util/lodash";
import { createComponent, PropTypes, Utils } from "../../../wayin-react";
import assetRefService from "../../../util/asset";
import MediaSettingsRepeatMenu from "./settings/media-settings-repeat-menu";
import MediaSettingsScrollMenu from "./settings/media-settings-scroll-menu";
import MediaSettingsSizeMenu from "./settings/media-settings-size-menu";
import { bgImageRepeats, bgImageScrollings, bgImageSizings } from "../../../enums";

var prepareAssetSettings = function prepareAssetSettings(children, assetRefObj) {
  var settings = _reduceInstanceProperty(_).call(_, children, function (acc, child) {
    if (Utils.isType(MediaSettingsRepeatMenu, child)) {
      var _child$props$defaultV = child.props.defaultValue,
          defaultValue = _child$props$defaultV === void 0 ? bgImageRepeats.NO_REPEAT : _child$props$defaultV;
      acc.repeat = _repeatInstanceProperty(assetRefObj.settings) || defaultValue;
    } else if (Utils.isType(MediaSettingsScrollMenu, child)) {
      var _child$props$defaultV2 = child.props.defaultValue,
          _defaultValue = _child$props$defaultV2 === void 0 ? bgImageScrollings.SCROLL : _child$props$defaultV2;

      acc.attachment = assetRefObj.settings.attachment || _defaultValue;
    } else if (Utils.isType(MediaSettingsSizeMenu, child)) {
      var _child$props$defaultV3 = child.props.defaultValue,
          _defaultValue2 = _child$props$defaultV3 === void 0 ? bgImageSizings.COVER : _child$props$defaultV3;

      acc.size = assetRefObj.settings.size || _defaultValue2;
    }

    return acc;
  }, _Object$assign({}, settings));

  return settings;
};

var MediaSettings = createComponent({
  displayName: 'MediaSettings',
  propTypes: {
    assetRef: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  },
  handlers: {
    handleChange: function handleChange(p) {
      return function (e, _ref) {
        var value = _ref.value,
            id = _ref.id;
        var assetRefObj = assetRefService.deserialize(p.assetRef);
        assetRefObj.settings[id] = value;
        p.setSettings(assetRefObj.settings);
        p.onChange(e, {
          id: p.id,
          value: assetRefService.serialize(assetRefObj)
        });
      };
    }
  },
  state: {
    settings: {
      value: {},
      updater: 'setSettings'
    }
  },
  lifecycles: {
    componentDidMount: function componentDidMount() {
      var assetRefObj = assetRefService.deserialize(this.props.assetRef); // Makes sure the actual assetRef reflects the same settings values that the controls show

      if (assetRefService.supportsSettings(assetRefObj)) {
        var children = React.Children.toArray(this.props.children);
        assetRefObj.settings = prepareAssetSettings(children, assetRefObj);
        this.props.setSettings(assetRefObj.settings);
        this.props.onChange(undefined, {
          id: this.props.id,
          value: assetRefService.serialize(assetRefObj)
        });
      }
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      var assetRefObj = assetRefService.deserialize(nextProps.assetRef);
      var oldAssetRefObj = assetRefService.deserialize(this.props.assetRef);
      /**
       * We are maintaining the settings in local state
       * If we receive a new assetRef that has a value (i.e. location), but previously did not
       * We want to trigger the onChange with the settings so that the assetRef reflects the settings values and they aren't just stored in local state
       */

      if (assetRefService.supportsSettings(assetRefObj) && !oldAssetRefObj.location) {
        var children = React.Children.toArray(this.props.children);
        assetRefObj.settings = prepareAssetSettings(children, assetRefObj);
        this.props.setSettings(assetRefObj.settings);
        this.props.onChange(undefined, {
          id: this.props.id,
          value: assetRefService.serialize(assetRefObj)
        });
      }
    }
  },
  render: function render(p) {
    var assetRefObj = assetRefService.deserialize(p.assetRef);

    var _p$settings = p.settings,
        size = _p$settings.size,
        attachment = _p$settings.attachment,
        repeat = _repeatInstanceProperty(_p$settings);

    var children = React.Children.toArray(p.children);
    /**
     * For now, we only want to show the settings when
     *  - it is an image
     *  - the service is "background" or "asset"
     *  - and and image is provided which we determine by the precense of a "location"
     * Arguablly this component shouldn't dictate that and it should be handled externally
     */

    return assetRefService.supportsSettings(assetRefObj) ? /*#__PURE__*/React.createElement("div", {
      className: "ck media-settings"
    }, _mapInstanceProperty(children).call(children, function (setting, i) {
      return /*#__PURE__*/React.createElement("div", {
        className: "media-settings__control",
        key: i
      }, Utils.isType(MediaSettingsSizeMenu, setting) ? /*#__PURE__*/React.cloneElement(setting, {
        value: size,
        onChange: p.handleChange
      }) : Utils.isType(MediaSettingsScrollMenu, setting) ? /*#__PURE__*/React.cloneElement(setting, {
        value: attachment,
        onChange: p.handleChange
      }) : Utils.isType(MediaSettingsRepeatMenu, setting) ? /*#__PURE__*/React.cloneElement(setting, {
        value: repeat,
        onChange: p.handleChange
      }) : null);
    }, this)) : null;
  }
});
MediaSettings.RepeatMenu = MediaSettingsRepeatMenu;
MediaSettings.ScrollMenu = MediaSettingsScrollMenu;
MediaSettings.SizeMenu = MediaSettingsSizeMenu;
export default MediaSettings;
//# sourceMappingURL=index.js.map